import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ProductReviewStars } from "./ProductReviewStars";
import { CtrlCollection } from "@yuigoto/ctrl";
import { ProductReviewControl } from "controls/ProductReviewControl";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { ControlRenderer } from "components/renderers/ControlRenderer";

import Styles from "components/glamclub/ProductReviewForm.module.scss";

class ProductReviewForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rating: 5,
      product_id: this.props.productId
    };

    this.collection = new CtrlCollection();
    for (let i in ProductReviewControl) {
      this.collection.add(ProductReviewControl[i]);
    }

    this.fetchProductReview = this.fetchProductReview.bind(this);
    this.updateStarsCallback = this.updateStarsCallback.bind(this);
    this.submitProductReview = this.submitProductReview.bind(this);
  }

  fetchProductReview() {
    this.props.showLoader();

    ExecuteRequest(
      GlamboxEndpoints.Product.getProductReview,
      null,
      "GET",
      {
        Authorization: this.props.token.Authorization
      },
      {
        productId: this.props.productId
      },
      (response) => {
        let {
          result,
          statusCode
        } = response;

        this.props.hideLoader();

        if (statusCode === 200) {
          let data = result;

          this.collection.setValue("title", (data) ? data.reviewTitle : "");
          this.collection.setValue("nickname", (data) ? data.nickname : "");
          this.collection.setValue("review", (data) ? data.review : "");

          this.setState({
            rating: (data) ? data.rating : 5
          });

          this.forceUpdate();
        }
      }
    );
  }

  submitProductReview(evt) {
    evt.preventDefault();
    if (this.collection.validate()) {
      this.props.showLoader();
  
      let formData = Object.assign(
        {},
        this.collection.toObject(),
        {
          productId: this.state.product_id,
          rating: this.state.rating
        }
      );

      ExecuteRequest(
        GlamboxEndpoints.Product.createProductReview,
        formData,
        "POST",
        {
          Authorization: this.props.token.Authorization
        },
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;

          this.props.hideLoader();

          if (statusCode === 200) {
            this.props.publishSuccessAlert(result.message || "Atualizado com sucesso!");

            if (this.props.onFinishSubmit) this.props.onFinishSubmit();
          } else {
            this.props.publishErrorAlert(
              (result && result.message) 
                ? result.message 
                : "Erro"
            );
          }
        }
      );
    } else {
      this.forceUpdate();
    }
  }

  updateStarsCallback(value) {
    this.setState({
      rating: value
    });
  }

  componentDidMount() {
    this.fetchProductReview();
  }

  render() {
    let { rating } = this.state;

    return (
      <div className={Styles["review-form"]}>
        <h2>SEU COMENTÁRIO</h2>
        <div className={Styles["review-form__row"]}>
          <div className={Styles["review-form__info"]}>
            <h4>COMO DAR SEU COMENTÁRIO</h4>
            <p>Nós queremos publicar a sua opinião, portanto, pedimos que observe os seguintes pontos:</p>

            <ul>
              <li>Mantenha seu comentário com foco no produto</li>
              <li>Evite escrever sobre o atendimento a clientes. Contate nosso suporte se possui problemas que merecem atenção imediata</li>
              <li>Tente não mencionar competidores ou o preço que você pagou no produto.</li>
              <li>Não inclua informações pessoais ou qualquer dado que possa te identificar (ex. seu nome completo)</li>
              <li>Não inclua links de qualquer tipo.</li>
            </ul>
          </div>
          <div className={Styles["review-form__form"]}>
            <form onSubmit={this.submitProductReview}>
              <div className={'text-center'}>
                <h5>Classificação</h5>
                <p className={"caption"}>
                  Estrelas representam uma nota de 1 a 5. Clique na mesma para selecionar.
                </p>
                <ProductReviewStars
                  rating={rating}
                  updateCallback={this.updateStarsCallback} />
              </div>

                {ControlRenderer.renderCollection(this.collection)}
        
              <p className={"text-center mb-4 mb-lg-0"}>
                <input type={"submit"} value={"Enviar"} />
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ProductReviewForm.propTypes = {
  productId: PropTypes.number.isRequired,
  onFinishSubmit: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    token: state.token.data
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: () => {
      dispatch(UiActions.loaderShow());
    },
    hideLoader: () => {
      dispatch(UiActions.loaderHide());
    },
    publishSuccessAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    publishErrorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message));
    }
  };
};

ProductReviewForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductReviewForm);

export { ProductReviewForm };
